import InvertGeoZoneIcon from './component'

export default InvertGeoZoneIcon
